import React from "react";
import {Box} from "@mui/material";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import {CollapsibleSection} from "~/pages/chat-agent/components/AgentActivity/CollapsibleSection";
import {thoughtMarkdownSx} from "~/pages/chat-agent/components/AgentActivity/agentActivity.styles";

type Props = {
    content: string;
    /** The turn is still streaming — an opened section follows new thoughts. */
    isActive: boolean;
};

/** The single thinking section of an agent turn; thoughts stream into it in place. */
export const ThinkingSection: React.FC<Props> = React.memo(({content, isActive}) => (
    <CollapsibleSection
        title={isActive ? "Thinking…" : "Thoughts"}
        isActive={isActive}
        scrollKey={content}
    >
        <Box sx={thoughtMarkdownSx}>
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
                {content}
            </ReactMarkdown>
        </Box>
    </CollapsibleSection>
));
